import * as React from 'react';

import ToriiLoader from '../../../components/utility/ToriiLoader';

const AuthCallback = () => (
  <ToriiLoader top={150} imageProps={{ style: { height: 300, width: 300 } }} />
);

export default AuthCallback;
